import { Directive, HostBinding, HostListener, Input } from '@angular/core';

/**
 * Base button class that both anchor and button directives can extend
 * to include all shared functionality.
 */
@Directive()
export class _BaseButtonDirective {
  @Input() color: ButtonTypes = 'primary';
  @Input() size: ButtonSizes = 'default';
  @Input() outline: boolean = false;

  // All styles need .btn set
  @HostBinding('class.btn') readonly _defaultClass = true;

  @HostBinding('class')
  get classes(): string {
    const classes: string[] = [];
    const color = this.color || 'primary';

    if (this.outline) {
      classes.push(`btn-outline-${color}`);
    } else {
      classes.push(`btn-${color}`);
    }

    if (this.size !== 'default') {
      classes.push(`btn-${this.size === 'large' ? 'lg' : 'sm'}`);
    }

    return classes.join(' ');
  }
}

// <a> and <button> tags handle disabled attribute differently so we
// split the directives in two and have the specific logic for
// disabling either a button or anchor in each one.

/**
 * A directive that applies our button styles to any button or a tags.
 */
@Directive({
  selector: 'button[psUiButton]',
})
export class ButtonDirective extends _BaseButtonDirective {
  @Input() @HostBinding() disabled: boolean = false;
}

@Directive({
  selector: 'a[psUiButton]',
})
export class ButtonAnchorDirective extends _BaseButtonDirective {
  @Input() @HostBinding('class.disabled') disabled: boolean = false;

  @HostListener('click', ['$event'])
  haltDisabledEvent(event: Event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}

export type ButtonTypes = 'primary' | 'secondary' | 'danger';
export type ButtonSizes = 'large' | 'small' | 'default';
